import { createApi } from '@reduxjs/toolkit/query/react';
import qs from 'qs';
import { baseQueryWithAuth } from './baseQueryWithAuth';
const ProbeApiService = createApi({
  reducerPath: 'probeApi',
  baseQuery: baseQueryWithAuth,
  paramsSerializer: params => qs.stringify(params, { encode: false }), // <== key part
  endpoints: builder => ({
    getWifiProbes: builder.query({
      query: payload => {
        const { screenId } = payload;
        return {
          url: `devices/${screenId}/wifi/probe`,
          method: 'GET',
          params: payload,
        };
      },
    }),

    getBluetoothClassicProbes: builder.query({
      query: payload => {
        const { screenId } = payload;
        return {
          url: `devices/${screenId}/bluetooth/classic/probe`,
          method: 'GET',
          params: payload,
        };
      },
    }),
  }),
});

export const { useGetWifiProbesQuery, useGetBluetoothClassicProbesQuery } = ProbeApiService;

export default ProbeApiService;
